import { Component, input, output } from '@angular/core';

@Component({
  selector: 'button[nttNavHamburger]',
  templateUrl: './nav-hamburger.html',
  styleUrl: './nav-hamburger.scss',
  host: {
    '[class.ntt-nav-hamburger--opened]': 'opened()',
    '(click)': 'handleClick()',
  },
})
export class NttNavHamburger {
  opened = input(false);
  openedChange = output<boolean>();

  handleClick(): void {
    this.openedChange.emit(!this.opened());
  }
}
